import { combineReducers } from 'redux';
import brandMetaData from './brandMetaData';

export default combineReducers({
  brandMetaData
});
